<div class="container pt-5 text-dark" *ngIf="about | async as aboutUs">
<h2>{{aboutUs.title}}</h2>
<p>{{aboutUs.intro}}</p>

<p>{{aboutUs.footer}}</p>
  <hr />


<app-clients></app-clients>


  <app-industries></app-industries>
</div>
